<template lang="pug">
  v-card
    v-card-title
      h2.modal-title {{ 'base.filter' | translate }}
    v-card-content
      .cols-x
        .cols-x__2
          v-input-r(
            :label="$t('base.price_from')"
            v-model="form.price_min")
        .cols-x__2
          v-input-r(
            :label="$t('base.price_to')"
            v-model="form.price_max")
      .cols-x
        .cols-x__2
          v-input-r(
            :label="$t('base.stock_rest_from')"
            v-model="form.amount_min")
        .cols-x__2
          v-input-r(
            :label="$t('base.stock_rest_to')"
            v-model="form.amount_max")
      .cols-x
        .cols-x__2.remove-margin-above-mobile
          v-select(
            :label="$t('base.delivery_type')"
            :options="deliveryTypes"
            v-model="form.delivery_type")
        .cols-x__2
          v-select(
            :label="$t('base.ingredient')"
            :options="ingredientsList"
            v-model="form.ingredient")
    v-card-actions
      v-btn(
        @click="addFilters")
        | {{ 'base.apply' | translate }}
      v-btn(
        text
        @click="removeFilters")
        | {{ 'base.clear' | translate }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FiltersModal',

  async mounted () {
    this.restoreFilters()
    const params = {
      farm: this.$route.params.farm_id
    }
    await this.loadIngredientsList(params)
  },

  data: (vm) => ({
    form: {
      price_min: null,
      price_max: null,
      amount_min: null,
      amount_max: null,
      ingredient: null,
      delivery_type: null
    },
    deliveryTypes: [
      { id: 'input', name: vm.$t('base.delivery') },
      { id: 'output', name: vm.$t('base.sale') }
    ]
  }),

  methods: {
    ...mapActions('ingredients', [
      'loadIngredientsList'
    ]),

    ...mapActions('deliveries', [
      'setFilters',
      'resetFilters'
    ]),

    restoreFilters () {
      for (const key in this.filters) {
        this.form[key] = this.filters[key]
      }
    },

    addFilters () {
      const filters = {}
      for (const key in this.form) {
        if (this.form[key] !== null) {
          filters[key] = this.form[key]
        }
      }
      filters.farm = this.$route.params.farm_id
      this.setFilters(filters)
      this.$emit('close')
    },

    removeFilters () {
      this.resetFilters()
      this.$emit('close')
    }
  },

  computed: {
    ...mapGetters('ingredients', [
      'ingredientsList'
    ]),

    ...mapGetters('deliveries', [
      'filters'
    ])
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
  display: flex;
  gap: 1rem;
}

.v-card__actions button:first-child {
  flex-basis: 50%;
}
</style>